(function () {
    'use strict';

    function excludeSelectedPartners() {
        return function (items, projectSharingConnections, projectEntityId) {
            var allSharingPartnerIds = _.map(projectSharingConnections, (function (item) {
                return item.EntityId;
            }));

            var filteredData = [];
            angular.forEach(items, function (item) {
                if (!(_.include(allSharingPartnerIds, item.EntityId)) && item.EntityId !== projectEntityId) {
                    filteredData.push(item);
                }
            });
            return filteredData;
        };
    }

    angular.module('ecap.common').filter('excludeSelectedPartners', excludeSelectedPartners);
})();